/** @jsxImportSource @emotion/react */

import { memo, useState } from "react";
import ImgComp, { ImgProps } from "react-cool-img";

import { container, img } from "./styles";

const Img = ({ className, src, ...rest }: ImgProps): JSX.Element => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div css={container(loaded)} className={className}>
      <ImgComp css={img} src={src} {...rest} onLoad={(): void => setLoaded(!!src)} />
    </div>
  );
};

export default memo(Img);
